/**
 * This generates the Help Page for the application
 * @param {*} props These are the properties required for the Help Page (user, etc)
 * @returns This returns a generated Help Page for the user
 */
import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { helpPageStyles } from "../core/styles/cards/helpPageStyles";
import HelpInfo from "./components/helpInfo";
import SupportForm from "./components/supportForm";
import FeedbackForm from "./components/feedbackForm";
import { SUPPORT_EMAIL } from "./configs/helpConfig";

const HelpPage = ({ props }) => {
  const theme = useTheme();
  const styles = helpPageStyles(theme);

  return (
    <Container sx={styles.mdHelpCard}>
      <Container>
        <Container>
          <Typography variant="body1" sx={styles.mdHelpTitle}>
            <p>
              Home / <span style={styles.mdHighlightText}>Help & Support</span>
            </p>
          </Typography>
        </Container>
      </Container>

      <Container>
        <Typography sx={styles.mdHelpText}>Need Help?</Typography>
      </Container>

      <Container>
        <Typography sx={styles.mdFreAsked}>
          Frequently Asked Questions
        </Typography>
      </Container>

      <HelpInfo />

      {/* Contact & feedback — replaces the old "email the CEO" line. */}
      <Container>
        <Typography sx={styles.mdFreAsked}>Contact us</Typography>
        <Typography sx={styles.mdSectionSubtitle}>
          Didn't find your answer above? Send us a support request or share
          feedback — or email{" "}
          <Link component="a" href={`mailto:${SUPPORT_EMAIL}`}>
            {SUPPORT_EMAIL}
          </Link>{" "}
          directly.
        </Typography>
      </Container>

      <Box sx={styles.mdFormsRow}>
        <SupportForm />
        <FeedbackForm />
      </Box>
    </Container>
  );
};

export default HelpPage;
